module.exports = __webpack_public_path__ + "static/media/snowflake-icon.3880330e.svg";